import { LoadableLazy } from '@confluence/loadable';

export const QuickSummaryStreamingComponent = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-QuickSummaryStreamingComponent" */ '../src/QuickSummaryStreaming/QuickSummaryStreamingEntryPoint.tsx'
			)
		).QuickSummaryStreamingEntryPoint,
});
